import { render, staticRenderFns } from "./WebLayout.vue?vue&type=template&id=573fc796&scoped=true&"
import script from "./WebLayout.vue?vue&type=script&lang=js&"
export * from "./WebLayout.vue?vue&type=script&lang=js&"
import style0 from "./WebLayout.vue?vue&type=style&index=0&id=573fc796&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573fc796",
  null
  
)

export default component.exports